<div class="w-full p-20 bg-pastel-blue border-box h-full scroll-y">
  <div class="bg-white radius-10 p-20">
    <div class="w-three-quarters margin-center">
      <div class="flex gap-20 align-items-center mb-30">
        <img src="assets/valid-circle-icon.svg" alt="">
        <div>
          <h1 *ngIf="step == 1" class="strong-green no-margin mb-10">Protocole PAP généré avec succès !</h1>
          <h1 *ngIf="step == 2" class="strong-green no-margin mb-10">Saisie des données CERFA validées</h1>

          <p *ngIf="step == 1" class="dark-blue no-margin">
            Votre modèle de protocole d'accord préélectoral a été généré et téléchargé. Vous pouvez maintenant passer à
            l'étape suivante : <span class="bold">la création du CERFA.</span>
          </p>
          <p *ngIf="step == 1" class="dark-blue no-margin">
            Voici un récapitulatif des étapes que vous avez complétées. Vous pouvez maintenant passer
            <span>à l'import de la liste électorale.</span>
          </p>
        </div>
      </div>

      <div class="flex gap-20 align-items-center mb-30">
        <div class="bg-light-gray p-20 radius-10 w-three-quarters" style="border: solid 1px #E3F2FF;">
          <div class="flex gap-20">
            <img src="assets/pap-icon.svg" alt="">
            <div>
              <h2 class="dark-blue no-margin mb-10">Étape 1 – Protocole d'accord préélectoral</h2>
              <p class="dark-gray no-margin text-sm">
                Votre modèle de protocole d'accord préélectoral a été généré avec succès.
              </p>
            </div>
          </div>
        </div>
        <app-tag [isValidated]="true"></app-tag>
      </div>

      <div *ngIf="step == 2" class="flex gap-20 align-items-center mb-30">
        <div class="bg-light-gray p-20 radius-10 w-three-quarters" style="border: solid 1px #E3F2FF;">
          <div class="flex gap-20">
            <img src="assets/cerfa-icon.svg" alt="">
            <div>
              <h2 class="dark-blue no-margin mb-10">Étape 2 – Édition automatique des CERFAS</h2>
              <p class="dark-gray no-margin text-sm">
                Les CERFAS seront générés automatiquement à la clôture du scrutin.
              </p>
            </div>
          </div>
        </div>
        <app-tag [isValidated]="true"></app-tag>
      </div>



      <div *ngIf="step == 1" class="flex content-between w-full"
        style="padding-top: 30px; border-top: solid 1px #E3F2FF;">
        <button type="button" class="edit-button" (click)="backToPapVerification()">Revenir sur la récapitulatif</button>
        <button type="button" class="action-button" (click)="goToCerfaCreation()">Passer à la création du
          CERFA</button>
      </div>
      <div *ngIf="step == 2" class="flex content-between w-full"
        style="padding-top: 30px; border-top: solid 1px #E3F2FF;">
        <button type="button" class="edit-button" (click)="backToCerfaVerification()">Revenir sur la validation du CERFA</button>
        <button type="button" class="action-button" (click)="goToPollCreation()">Passer à la création du
          scrutin</button>
      </div>
    </div>

  </div>
</div>